import React from 'react';
import { BiMap } from 'react-icons/bi';
import { FaEnvelope, FaFacebookF, FaLinkedin, FaInstagram, FaPhoneAlt, FaTwitter, FaVimeoV } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { businessLogic } from '../../../lib/constants';
import PrelaunchForm from '../Prelaunch/prelaunchForm';
import { useTranslation } from "react-i18next";
import { trackConversion } from "../../../lib/analytics";


const CoreDetails = () => {
   const { t } = useTranslation();

   return (
      <>
          <section className="team__details pt-120 pb-160">
             <div className="container" style={{ position: 'relative' }}>
                <div className="team__details-inner p-relative white-bg" style={{ transform: 'scale(0.85)', transformOrigin: 'top center' }}>
                   <div className="row">
                      <div className="col-xl-6 col-lg-6">
                         <div className="team__details-img w-img mr-70" style={{ position: 'relative', aspectRatio: '9 / 16', overflow: 'hidden' }}>
                             <iframe
                               src="https://www.youtube-nocookie.com/embed/893YvVnG67g?autoplay=1&mute=1&loop=1&playlist=893YvVnG67g&controls=0&modestbranding=1&rel=0"
                               title="What We Do"
                               frameBorder="0"
                               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                               style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '30px 0 0 30px' }}
                             />
                         </div>
                      </div>
                      <div className="col-xl-6 col-lg-6">
                         <div className="team__details-content pt-105">
                            <span> {t("core_coreprelaunch_title_mini")} </span>
                            <h3>{t("core_coreprelaunch_title_slogan")}</h3>
                            <p>{t("core_coreprelaunch_description")}</p>
                             <PrelaunchForm/>
                            <div className="team__details-social theme-social" >
                               <ul>
                                  <li>
                                  <a href={`${businessLogic.linkedin}`} target="_blank" rel="noreferrer">
                                        <i ><FaLinkedin/> </i>
                                        <i ><FaLinkedin/> </i>
                                     </a>
                                  </li>
                                  <li>
                                  <a href={`${businessLogic.instagram}`} target="_blank" rel="noreferrer">
                                        <i ><FaInstagram/> </i>
                                        <i ><FaInstagram/> </i>
                                     </a>
                                  </li>
                                  <li>
                                  <a href={`${businessLogic.facebook}`} target="_blank" rel="noreferrer">
                                        <i ><FaFacebookF/></i>
                                        <i ><FaFacebookF/></i>
                                     </a>
                                  </li>
                               </ul>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div className="row">
                   <div className="col-xl-10 offset-xl-1">
                      <div className="team__details-info mt-60">
                         <h4 >{t("core_coreprelaunch_title_more_info")}</h4>
                         <p >{t("core_coreprelaunch_description1_more_info")}</p>
                         <p >{t("core_coreprelaunch_description2_more_info")}</p>
                         <Link
                            to="/get-started"
                            className="z-btn mt-10"
                            onClick={() => trackConversion("Home Core - Get Started")}
                         >
                            {t("home_core_start_cta")}
                         </Link>
                      </div>
                   </div>
                </div>
             </div>
          </section>
      </>
   );
};

export default CoreDetails;
